// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// App guards, models, etc.
import { hpcEnabledGuard } from './core/guards/hpc-enabled.guard';
import { authGuard } from './core/guards/auth.guard';
import { LocalePrefixGuard } from './core/guards/language.guard';
import { redirectToLocalePrefixGuard } from './core/guards/language-redirect.guard';
import { RouterPath } from './shared/models';

// Components
import { HomeComponent } from './views/home/home.component';

/**
 * Child routes that will be nested under the language prefix.
 * These are the actual application routes.
 */
const appRoutes: Routes = [
    {
        path: RouterPath.HOME,
        component: HomeComponent
    },
    {
        path: RouterPath.GET_DATA,
        loadChildren: () => import('./views/data-products/data-products.module').then(m => m.DataProductsModule),
        canActivate: [authGuard]
    },
    {
        path: RouterPath.DEMO,
        loadChildren: () => import('./views/data-products/data-products.module').then(m => m.DataProductsModule),
    },
    {
        path: RouterPath.SERVICES,
        loadChildren: () => import('./views/services/services.module').then(m => m.ServicesModule)
    },
    {
        path: RouterPath.PRICING,
        loadChildren: () => import('./views/pricing/pricing.module').then(m => m.PricingModule)
    },
    {
        path: RouterPath.PROFILE,
        loadChildren: () => import('./views/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [authGuard]
    },
    {
        path: RouterPath.DOCS,
        loadChildren: () => import('./views/docs/docs.module').then(m => m.DocsModule)
    },
    {
        // HPC OnDemand: package intro, personal checkout, organization registration
        path: RouterPath.HPC,
        canMatch: [hpcEnabledGuard],
        loadChildren: () => import('./views/hpc/hpc.module').then(m => m.HpcModule)
    },
    {
        // Static pages (about, faqs, register, forms, etc.) + 404 wildcard.
        // Empty path so it mounts at this same level without changing URLs; must stay last so
        // the routes above get first chance to match before falling through to its '**' catch-all.
        path: '',
        loadChildren: () => import('./views/static-pages/static-pages.module').then(m => m.StaticPagesModule)
    },
];

const routes: Routes = [
    // Redirect root to language-prefixed home
    {
        path: '',
        pathMatch: 'full',
        canActivate: [redirectToLocalePrefixGuard],
        // This component won't be loaded as the guard redirects
        component: HomeComponent
    },
    // Language-prefixed routes (e.g., /en/..., /vi/...)
    {
        path: ':lang',
        canMatch: [LocalePrefixGuard],
        children: appRoutes
    },
    // Fallback: redirect any non-prefixed paths to language-prefixed version
    {
        path: '**',
        canActivate: [redirectToLocalePrefixGuard],
        // This component won't be loaded as the guard redirects
        component: HomeComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
